import { EpicPmConnectForm } from './EpicPmConnectForm'
import type { VendorConnectorProps } from './types'

export function EpicPmConnector({ onConnected }: VendorConnectorProps) {
  return <EpicPmConnectForm onConnected={() => onConnected?.()} />
}
